var list = {
  // dashboard for all the users
  dashboard: {
    singular_name: "Dashboard",
    plural_name: "Dashboard",
    type: "item",
    icon: "fa fa-dashboard",
    router: {
      name: "Dashboard"
    }
  },
  // settings for admins
  settings: {
    singular_name: "Setting",
    plural_name: "Settings",
    type: "item",
    icon: "fa fa-cogs",
    router: {
      name: "Settings"
    }
  },
  // configuration - START
  perm: {
    singular_name: "Permission",
    plural_name: "Permissions",
    type: "item",
    icon: "fa fa-user-secret",
    router: {
      name: "Permission"
    }
  },

  role: {
    singular_name: "Role",
    plural_name: "Roles",
    type: "item",
    icon: "fa fa-users",
    router: {
      name: "Role"
    }
  },
  announcement: {
    singular_name: "Announcement",
    plural_name: "Announcements",
    type: "item",
    icon: "fa fa-bullhorn",
    router: {
      name: "Announcement"
    }
  },
  user: {
    singular_name: "Admin",
    plural_name: "Admins",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "User"
    }
  },
  label_report: {
    singular_name: "Label Report",
    plural_name: "Label Report",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "LabelReport"
    }
  },
  // configuration - END
  // masters for admins - START
  race: {
    singular_name: "Race",
    plural_name: "Races",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "Races"
    }
  },
  gen_id: {
    singular_name: "Gender Identity",
    plural_name: "Gender Identities",
    type: "item",
    icon: "fa fa-intersex",
    router: {
      name: "GenderIdentities"
    }
  },
  sex_with: {
    singular_name: "Sex With",
    plural_name: "Sex with",
    type: "item",
    icon: "fa fa-intersex",
    router: {
      name: "SexWith"
    }
  },
  sex_at_birth: {
    singular_name: "Sex at birth",
    plural_name: "Sex at birth",
    type: "item",
    icon: "fa fa-intersex",
    router: {
      name: "SexAtBirth"
    }
  },
  navajo_zip: {
    singular_name: "Navajo Zip Code",
    plural_name: "Navajo Zip Codes",
    type: "item",
    icon: "fa fa-2x fa-code-fork",
    router: {
      name: "NavajoZipCode"
    }
  },
  test_order: {
    singular_name: "Upload Test Order",
    plural_name: "Upload Test Orders",
    type: "item",
    icon: "fa fa-upload",
    router: {
      name: "UploadTestOrder"
    }
  },
  remin_queue: {
    singular_name: "Reminder History",  //"Reminder Queue"
    plural_name: "Reminder Histories", //"Reminder Queues"
    type: "item",
    icon: "fa fa-align-justify",
    router: {
      name: "ReminderQueues"
    }
  },
  state: {
    singular_name: "State",
    plural_name: "States",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "States"
    }
  },
  disease: {
    singular_name: "Disease",
    plural_name: "Diseases",
    type: "item",
    icon: "fa fa-search-plus",
    router: {
      name: "Diseases"
    }
  },
  how_heard: {
    singular_name: "How Heard",
    plural_name: "How Heard",
    type: "item",
    icon: "fa fa-microphone",
    router: {
      name: "HowHeard"
    }
  },
  spec_type: {
    singular_name: "Specimen Type",
    plural_name: "Specimen Types",
    type: "item",
    icon: "fa fa-medkit",
    router: {
      name: "SpecimenTypes"
    }
  },
  clinic: {
    singular_name: "Clinic",
    plural_name: "Clinics",
    type: "item",
    icon: "fa fa-hospital-o",
    router: {
      name: "Clinic"
    }
  },
  test_type: {
    singular_name: "Specimen Type",
    plural_name: "Specimen Types",
    type: "item",
    icon: "fa fa-flask",
    router: {
      name: "TestTypes"
    }
  },
  test_kit: {
    singular_name: "Test Kit",
    plural_name: "Test Kits",
    type: "item",
    icon: "fa fa-medkit",
    router: {
      name: "TestKits"
    }
  },
  assay_type: {
    singular_name: "Assay Type",
    plural_name: "Assay Types",
    type: "item",
    icon: "fa fa-list-ul",
    router: {
      name: "AssayTypes"
    }
  },
  symptom: {
    singular_name: "Symptom",
    plural_name: "Symptoms",
    type: "item",
    icon: "fa fa-stethoscope",
    router: {
      name: "Symptoms"
    }
  },
  // masters for admins - END
  // TEMP : orders menu for user
  orders: {
    singular_name: "Order",
    plural_name: "Orders",
    type: "item",
    icon: "fa fa-shopping-cart",
    router: {
      name: "Orders"
    }
  },
  upload_test_results_module_code: {
    singular_name: "Upload Test Result",
    plural_name: "Upload Test Results",
    type: "item",
    icon: "fa fa-upload",
    router: {
      name: "UploadTestResults"
    }
  },
  verify_test_results_module_code: {
    singular_name: "Verify Test Result",
    plural_name: "Verify Test Results",
    type: "item",
    icon: "fa fa-check-square",
    router: {
      name: "VerifyTestResults"
    }
  },
  reports: {
    singular_name: "Legacy Report",
    plural_name: "Legacy Reports",
    type: "item",
    icon: "fa fa-file",
    router: {
      name: "Reports"
    }
  },
  risk_assessment_module: {
    singular_name: "Risk Assessment",
    plural_name: "Risk Assessments",
    type: "item",
    icon: "fa fa-exclamation-triangle",
    router: {
      name: "RiskAssessment"
    }
  },
  user_profile: {
    singular_name: "Profile",
    plural_name: "Profile",
    type: "item",
    icon: "fa fa-user-circle",
    router: {
      name: "UpdateProfile"
    }
  },
  results: {
    singular_name: "Results",
    plural_name: "Results",
    type: "item",
    icon: "fa fa-file",
    router: {
      name: "Orders"
    }
  },
  message_center: {
    singular_name: "Message Center",
    plural_name: "Message Center",
    type: "item",
    icon: "fa fa-envelope",
    router: {
      name: "MessageCenter"
    }
  },
  // TEMP : participants menu for admin
  participants: {
    singular_name: "Participant",
    plural_name: "Participants",
    type: "item",
    icon: "fa fa-users",
    router: {
      name: "Participants"
    }
  },
  external_admin: {
    singular_name: "External Admin",
    plural_name: "External Admins",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "ExternalAdmin"
    }
  },
  sponsor: {
    singular_name: "Sponsor User",
    plural_name: "Sponsor Users",
    type: "item",
    icon: "fa fa-user",
    router: {
      name: "SponsorUserList"
    }
  },
  order_result: {
    singular_name: "Order Results",
    plural_name: "Order Results",
    type: "item",
    icon: "fa fa-hospital-o",
    router: {
      name: "OrderResult"
    }
  },
  region: {
    singular_name: "Region",
    plural_name: "Regions",
    type: "item",
    icon: "fa fa-globe",
    router: {
      name: "RegionList"
    }
  },
  monthly_reports: {
    singular_name: "Monthly Reports",
    plural_name: "Monthly Reports",
    type: "item",
    icon: "fa fa-bar-chart",
    router: {
      name: "MonthlyReports"
    }
  },
  line_items: {
    singular_name: "Line Item Data",
    plural_name: "Line Item Data",
    type: "item",
    icon: "fa fa-list-ul",
    router: {
      name: "LineItemData"
    }
  },
  positive_report: {
    singular_name: "Positivity Report",
    plural_name: "Positivity Report",
    type: "item",
    icon: "fa fa-plus-square",
    router: {
      name: "PositiveReport"
    }
  }
};
export default {
  get: function(module_code, data = {}) {
    var info = list[module_code];
    if (!info) {
      console.log("NEW MODULE TO BE ADDED : ", module_code);

      return {
        icon: "fa fa-star",
        type: module_code,
        module_code: module_code,
        id: module_code,
        name: module_code,
        plural_name: module_code,
        singular_name: module_code,
        router: {
          name: "ComingSoon"
        }
      };
    }

    return {
      ...data,
      icon: info.icon,
      type: info.type,
      router: info.router,
      module_code: module_code,
      name: info.plural_name,
      plural_name: info.plural_name,
      singular_name: info.singular_name
    };
  }
};
